import React, { forwardRef, useState } from 'react'

import BlurContainer from '../BlurContainer'
import Link from '@atoms/Link'
import VideoModal from '@src/components/VideoModal'
import { useTranslation } from '@models/Translation'
import { Video } from '@src/models/Video'

import * as style from './style.module.sass'
import MixBlendContainer from '../MixBlendContainer'

type VideoSectionProps = {
  allVideos: Video[]
}
const VideoSection = forwardRef<HTMLElement, VideoSectionProps>(
  ({ allVideos }, ref) => {
    const { locale, t } = useTranslation()

    const mainVideo = allVideos[0]
    const videos = allVideos.slice(1, 5)
    const [selectedVideoIndex, setSelectedVideoIndex] = useState<
      number | undefined
    >()

    return (
      <section className={style.section} ref={ref}>
        <BlurContainer>
          <MixBlendContainer>
            <h2>Videos</h2>
          </MixBlendContainer>
          <div
            className={style.message}
            dangerouslySetInnerHTML={{ __html: t('artisan.video') }}
          />
        </BlurContainer>

        <BlurContainer>
          <div className={style.videos}>
            <div className={style.main}>
              <iframe
                src={`https://www.youtube.com/embed/${mainVideo.videoId}`}
              />
              <div className={style.name}>
                {locale === 'ja' ? mainVideo.title : mainVideo.titleEn}
              </div>
              <div className={style.tags}>
                {(locale === 'ja' ? mainVideo.tags : mainVideo.tagsEn).map(
                  tag => (
                    <span className={style.tag} key={tag}>
                      #{tag}
                    </span>
                  ),
                )}
              </div>
            </div>
            <div className={style.list}>
              {videos.map((video, index) => (
                <button
                  className={style.item}
                  key={video.videoId}
                  onClick={() => setSelectedVideoIndex(index)}
                >
                  <img
                    src={`https://i.ytimg.com/vi/${video.videoId}/hqdefault.jpg`}
                    alt={locale === 'ja' ? video.title : video.titleEn}
                  />
                  <div>
                    <div className={style.name}>
                      {locale === 'ja' ? video.title : video.titleEn}
                    </div>
                    <div className={style.tags}>
                      {(locale === 'ja' ? video.tags : video.tagsEn).map(
                        tag => (
                          <span className={style.tag} key={tag}>
                            #{tag}
                          </span>
                        ),
                      )}
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>

          <Link
            to="https://www.youtube.com/@Artisan-ftn"
            className={style.link}
          >
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none">
              <path
                d="M17.812 5.66116H6.145C3.855 5.66116 2 7.49616 2 9.76016V15.5282C2 17.7922 3.856 19.6282 6.145 19.6282H17.812C20.102 19.6282 21.957 17.7922 21.957 15.5282V9.76016C21.957 7.49616 20.101 5.66016 17.812 5.66016V5.66116ZM15.009 12.9242L9.552 15.4992C9.51872 15.5152 9.48192 15.5225 9.44503 15.5205C9.40815 15.5185 9.37237 15.5072 9.34103 15.4876C9.3097 15.4681 9.28382 15.4409 9.2658 15.4086C9.24779 15.3764 9.23822 15.3401 9.238 15.3032V9.99416C9.23867 9.95703 9.24872 9.92068 9.26722 9.88848C9.28573 9.85629 9.31208 9.8293 9.34382 9.81003C9.37556 9.79077 9.41167 9.77985 9.44877 9.7783C9.48587 9.77675 9.52276 9.78461 9.556 9.80116L15.014 12.5362C15.0504 12.5543 15.0809 12.5823 15.102 12.617C15.1232 12.6517 15.1341 12.6916 15.1336 12.7322C15.1331 12.7728 15.1211 12.8125 15.0991 12.8466C15.077 12.8807 15.0458 12.908 15.009 12.9252V12.9242Z"
                fill="currentColor"
              />
            </svg>
            {t('video.more')}
          </Link>
        </BlurContainer>

        <VideoModal
          video={
            selectedVideoIndex === undefined
              ? undefined
              : videos[selectedVideoIndex]
          }
          onClose={() => setSelectedVideoIndex(undefined)}
        />
      </section>
    )
  },
)

export default VideoSection
